var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 33.75C26.6985 33.75 33.75 26.6985 33.75 18C33.75 9.30152 26.6985 2.25 18 2.25C9.30152 2.25 2.25 9.30152 2.25 18C2.25 26.6985 9.30152 33.75 18 33.75Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.185 18C22.185 18.825 21.945 19.635 21.48 20.325C21.015 21.015 20.37 21.54 19.605 21.855C18.84 22.185 18 22.26 17.19 22.095C16.38 21.945 15.63 21.54 15.045 20.955C14.46 20.37 14.07 19.62 13.905 18.81C13.74 18 13.83 17.16 14.145 16.395C14.46 15.645 15 14.985 15.69 14.52C16.365 14.07 17.175 13.83 18 13.83C19.11 13.83 20.175 14.265 20.955 15.045C21.75 15.825 22.185 16.89 22.185 18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.595 10.62L10.605 11.61L13.05 14.055L14.04 13.065L11.595 10.62Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.73 17.31H8.25V18.705H11.73V17.31Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.05 21.96L10.605 24.405L11.595 25.395L14.04 22.95L13.05 21.96Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.69 24.27H17.295V27.75H18.69V24.27Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.95 21.96L21.96 22.95L24.405 25.395L25.395 24.405L22.95 21.96Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 17.31H24.27V18.705H27.75V17.31Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.405 10.62L21.96 13.065L22.95 14.055L25.395 11.61L24.405 10.62Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.69 8.25H17.295V11.73H18.69V8.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSun);
export default __webpack_public_path__ + "static/media/ic-sun.67bdcf3b8b11d8e63730aa52fbcfbb42.svg";
export { ForwardRef as ReactComponent };